import React, { useState } from 'react';

import Confirm from '../../themed/confirm';
import Modal from '../../themed/modal';

import { clearSingleProjectCache } from '../../../services/reportCache';
import { getErrorMessage } from '../../../utils/utilities';

import classNames from './styles.module.scss';
import toastService from '../../../services/toastService';

interface Props {
    projectId: string;
}

const ClearReportCacheButton: React.FC<Props> = ({ projectId }) => {
    const [isConfirmVisible, setConfirmVisible] = useState(false);

    const deleteProjectCache = React.useCallback(() => {
        toastService.promise(clearSingleProjectCache(projectId), {
            loading: `Clearing Project Cache`,
			success: `Project Cache Cleared`,
			error: getErrorMessage,
        })
    }, [projectId]);

    return ( 
        <>
            <Modal
                style={{ height: 'auto', maxWidth: '50%' }}
                isVisible={isConfirmVisible}
                onClose={() => setConfirmVisible(false)}
            >
                <div className="p-3">
                    <Confirm
                        title="Confirm Cache Deletion"
                        message={`Are you sure you want to clear this cache? This cannot be undone`}
                        onCancel={() => setConfirmVisible(false)}
                        onConfirm={() => deleteProjectCache()}
                    />
                </div>
            </Modal>

            <button
                className={classNames.clearCacheButton}
                onClick={() => setConfirmVisible(true)}
            >
                <i className="bi bi-x-square-fill"></i>
            </button>
        </>
    );
};
 
export default ClearReportCacheButton;